module.exports = __webpack_public_path__ + "static/media/product-11.ecd66f42.jpg";